export function toggleNavigation(navigation, navigationPrev, navigationNext) {       
    function checkThisBox() {
        const index = $(`${navigation}.active`).attr('data-item');
    
        if (index == 0) {
            $(navigationPrev).addClass('disabled');
        } else {
            $(navigationPrev).removeClass('disabled');
        }
    
        if (index == $(navigation).length - 1) {
            $(navigationNext).addClass('disabled');
        } else {
            $(navigationNext).removeClass('disabled');
        }

        $(`${navigation}.active`).find('a').click();
    }
    
    checkThisBox();
    
    $(navigationPrev).click(function(e) {
        e.preventDefault();
    
        if (!$(this).hasClass('disabled')) {
            const i = parseInt($(`${navigation}.active`).attr("data-item"));
            const newI = i - 1;
    
            $(navigation).removeClass("active");
            $(`${navigation}[data-item=${newI}]`).addClass("active");

            checkThisBox();
        }
    });
    
    $(navigationNext).click(function(e) {
        e.preventDefault();
    
        if (!$(this).hasClass('disabled')) {
            const i = parseInt($(`${navigation}.active`).attr("data-item"));
            const newI = i + 1;
    
            $(navigation).removeClass("active");
            $(`${navigation}[data-item=${newI}]`).addClass("active");

            checkThisBox();
        }
    });
}